import React from 'react';

import { fg } from '@townsquare/stat-sig/gate';

export type CollaborationContext = {
	goalWorkspace: string | null;
	projectWorkspace: string | null;
	rovoWorkspace: string | null;
	contextId?: string | null;
	orgCloudIds: string[] | null;
	collabContextScoping?: {
		collabContextCloudIds?: string[];
		isMultiSite?: boolean;
		collabContextSiteAris?: string[];
		hasMultipleUnits?: boolean;
	} | null;
};

export const CollabContext = React.createContext<CollaborationContext | null>(null);

export const useCollabContext = () => {
	return React.useContext(CollabContext);
};

export const useRovoWorkspace = () => {
	const context = useCollabContext();
	return context?.rovoWorkspace;
};

export const useGoalWorkspace = () => {
	const context = useCollabContext();
	return context?.goalWorkspace ?? null;
};

export const useProjectWorkspace = () => {
	const context = useCollabContext();
	return context?.projectWorkspace ?? null;
};

export const useContextId = () => {
	const context = useCollabContext();
	return context?.contextId ?? null;
};

export const useCollabContextCloudIds = () => {
	const context = useCollabContext();
	const collabContextCloudIdsEnabled =
		fg('townsquare_enable_collab_context_cloud_ids') && !!context?.collabContextScoping?.collabContextCloudIds;

	const cloudIds = collabContextCloudIdsEnabled
		? context?.collabContextScoping?.collabContextCloudIds
		: context?.orgCloudIds;

	return cloudIds ?? [];
};
